import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import { IScoreCard } from "../../backend/model/model";
import { getRootScorecards } from "../../backend/model/getRootScorecards";
import { getChildScorecards } from "../../backend/model/getChildScorecards";
import { useQuery } from "react-query";

const useStyles = makeStyles({
  root: {
    height: 110,
    flexGrow: 1,
    maxWidth: 400,
  },
});

const ShowScoreCard = (props: {
  scorecard: IScoreCard;
  onSelect?: (card: IScoreCard) => void;
}) => {
  const { isLoading, data } = useQuery(`scorecards${props.scorecard.id}`, () =>
    getChildScorecards(props.scorecard.id)
  );
  if (isLoading) return null;
  const { scorecard } = props;
  return (
    <TreeItem
      key={scorecard.id}
      nodeId={scorecard.id}
      label={`${scorecard.name} ${scorecard.symbol}`}
      onClick={() => {
        if (props.onSelect) props.onSelect(scorecard);
      }}
    >
      {data?.map((item) => {
        return <ShowScoreCard scorecard={item} onSelect={props.onSelect} />;
      })}
    </TreeItem>
  );
};

export default function ScorecardNavigator(props: {
  onSelect?: (card: IScoreCard) => void;
}) {
  const classes = useStyles();
  const { isLoading, data } = useQuery("rootScorecard", () =>
    getRootScorecards()
  );

  if (isLoading) return null;
  return (
    <TreeView
      className={classes.root}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpanded={["root"]}
      defaultExpandIcon={<ChevronRightIcon />}
    >
      {data?.map((item) => {
        return <ShowScoreCard scorecard={item} onSelect={props.onSelect} />;
      })}
    </TreeView>
  );
}
